export default __webpack_public_path__ + "assets/logos/a2b42685bc53c0e001e7561b28d4bae9.png";